import { Injectable } from '@angular/core';
import {AbstractSaveOneService} from '../../../../../core/service/v2/service/save/abstractSaveOne.service';
import {LovValueSavePayload} from './payload/lovValueSave.payload';
import {LovValue} from '../../api/model/LovValue.model';
import {LovValueRepository} from './ngrx/lovValue.repository';
import {LovValueDataServiceAdapter} from './ngrx/lovValueDataService.adapter';

@Injectable()
export class LovValueSaveService extends AbstractSaveOneService<LovValue, LovValueSavePayload> {

    constructor(repository: LovValueRepository, dataServiceAdapter: LovValueDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
